import constants from '@/constants'
const {
  IST,
  IST_OFFSET,
  WIB,
  WIB_OFFSET,
  WITA,
  WITA_OFFSET,
  WIT,
  WIT_OFFSET,
  UTC,
  UTC_OFFSET
} = constants.timeZone

export const getLocale = () => {
  if (!window.localStorage.getItem('OMG_APPLE_TRANSLATE_LANG_KEY')) {
    window.localStorage.setItem('OMG_APPLE_TRANSLATE_LANG_KEY', 'ID')
  }
  return window.localStorage.getItem('OMG_APPLE_TRANSLATE_LANG_KEY') || 'ID'
}

export const setLocale = (locale) => {
  window.localStorage.setItem('OMG_APPLE_TRANSLATE_LANG_KEY', locale)
  window.location.reload()
}

export const getTimeZone = () => {
  const offset = new Date().getTimezoneOffset()
  switch (offset) {
    case IST_OFFSET:
      return IST
    case WIB_OFFSET:
      return WIB
    case WITA_OFFSET:
      return WITA
    case WIT_OFFSET:
      return WIT
    case UTC_OFFSET:
      return UTC
    default:
      return ''
  }
}

export const convertBase64ToBlob = (base64FileContent) => {
  const base64XlsxData = base64FileContent
  const mimeType = 'application/octet-stream'
  const binaryString = atob(base64XlsxData)
  const byteArray = new Uint8Array(binaryString.length)
  for (let i = 0; i < binaryString.length; i++) {
    byteArray[i] = binaryString.charCodeAt(i)
  }
  return new Blob([byteArray], { type: mimeType })
}

export function getCondensedBannersConfigResponse (response) {
  return response?.map(component => {
    const bannerProperties = component.parameters[0]
    return {
      parameters: [
        {
          id: bannerProperties.id,
          image: bannerProperties.image,
          url: bannerProperties.url
        }
      ]
    }
  })
}

export function setLocalStorageAppConfiguration (typeOfConfiguration, config) {
  window.localStorage.setItem(typeOfConfiguration, config)
}

export function getLocalStorageAppConfiguration (typeOfConfiguration) {
  return window.localStorage.getItem(typeOfConfiguration)
}

export const setSessionUpdatedDate = () => {
  const currentDate = new Date()
  currentDate.setHours(0, 0, 0, 0)
  window.localStorage.setItem(constants.SESSION_UPDATED_DATE, currentDate.getTime())
}

export const shouldMakeSessionUpdateCall = () => {
  let lastSessionUpdateDate = window.localStorage.getItem(constants.SESSION_UPDATED_DATE)
  if (!lastSessionUpdateDate) {
    return true
  }
  const currentDate = new Date()
  currentDate.setHours(0, 0, 0, 0)
  return currentDate.getTime() > lastSessionUpdateDate
}

export const clearSessionUpdatedDate = () => {
  window.localStorage.removeItem(constants.SESSION_UPDATED_DATE)
}

export const clearFcmTokens = () => {
  window.localStorage.removeItem(constants.FCM_TOKEN)
  window.localStorage.removeItem(constants.FCM_TOKEN_TIMESTAMP)
}

export function getThreeMonthNames (startDate, locale = 'id-ID', options = { month: 'long' }) {
  const monthNameList = []
  if (!startDate) {
    return monthNameList
  }
  const date = new Date(startDate)
  date?.setDate(1)
  for (let i = 0; i < 3; i++) {
    monthNameList.push(date.toLocaleString(locale, options))
    date.setMonth(date.getMonth() + 1)
  }
  return monthNameList
}

export function postEventMessageToIOS (eventName, data) {
  window.webkit?.messageHandlers?.[eventName]?.postMessage(data)
}

const userAgent = navigator.userAgent
export const isIOSAppCheck = navigator.userAgent.includes('AppleReseller_iOS')
export const isIOSVersionBeforeBlue = navigator.userAgent.includes('AppleReseller_iOS-1.0')
const parentChildunSupportedVersions = ['AppleReseller_iOS-1.0', 'AppleReseller_iOS-1.2']
export const isIOSAppParentChildUnsupportedVersion = parentChildunSupportedVersions.some(version => userAgent.includes(version))

export const emitEventToPiniaStore = (eventType, data = {}) => {
  window.dispatchEvent(new CustomEvent('update.pinia.state.from.vuex',
    { detail: { eventType, data } }))
}

export function getLocalStorageItem (key) {
  return window.localStorage.getItem(key)
}

export function removeLocalStorageItem (key) {
  return window.localStorage.removeItem(key)
}
